"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = Login;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const auth_1 = require("@src/types/auth");
const types_1 = require("@src/types");
const react_router_dom_1 = require("react-router-dom");
const elements_1 = require("@src/components/elements");
const separator_1 = __importDefault(require("components/modules/global/separator"));
const login_form_1 = __importDefault(require("components/modules/login-form"));
const FacebookLoginButton_1 = require("@src/components/elements/FacebookLoginButton");
const GoogleLoginButton_1 = require("@src/components/elements/GoogleLoginButton");
const LinkedInLoginButton_1 = require("@src/components/elements/LinkedInLoginButton");
const antd_1 = require("antd");
const Api = __importStar(require("@src/api"));
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const useLogin_1 = require("@src/hooks/useLogin");
function Login() {
    const intl = (0, react_intl_1.useIntl)();
    const { login, isLoading: isLoginLoading, error: loginError } = (0, useLogin_1.useLogin)();
    const history = (0, react_router_dom_1.useHistory)();
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const onSuccessfulCodeAcquisition = async (code) => {
        try {
            const user = await Api.Auth.linkedinAuthentication(code);
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
            if (user.account_type_id === types_1.AccountType.company) {
                // @ts-ignore
                history.pushLocalized('/admin');
            }
            else {
                // @ts-ignore
                history.pushLocalized('/ucet');
            }
        }
        catch (error) {
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'login.error',
                }),
                description: intl.formatMessage({
                    id: 'login.something_went_wrong',
                }),
            });
        }
    };
    react_1.default.useEffect(() => {
        const { code: codeForAccessToken, state: obtainedLinkedinStateString, error } = history.getQuery();
        if (obtainedLinkedinStateString) {
            const initialLinkedinStateString = window.localStorage.getItem('pracuj_linkedin_state_string');
            if (initialLinkedinStateString === obtainedLinkedinStateString) {
                if (codeForAccessToken !== undefined) {
                    setIsLoading(true);
                    onSuccessfulCodeAcquisition(codeForAccessToken);
                }
                else if (error) {
                    antd_1.notification.warning({
                        message: intl.formatMessage({
                            id: 'general.notification',
                        }),
                        description: intl.formatMessage({
                            id: 'login.error_user_cancelled_login',
                        }),
                    });
                }
            }
            else {
                antd_1.notification.error({
                    message: intl.formatMessage({
                        id: 'general.error',
                    }),
                    description: intl.formatMessage({
                        id: 'login.error_unauthorized',
                    }),
                });
            }
            window.localStorage.removeItem('pracuj_linkedin_state_string');
        }
    }, []);
    return (
    // @ts-ignore
    (0, jsx_runtime_1.jsx)(antd_1.Spin, { size: "large", spinning: isLoading, children: (0, jsx_runtime_1.jsx)(elements_1.Holder, { marginVertical: true, "data-cy": "login", children: (0, jsx_runtime_1.jsxs)(antd_1.Row, { justify: "center", gutter: [16, 16], children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, md: { span: 12 }, xl: { span: 10 }, children: (0, jsx_runtime_1.jsxs)("div", { className: "panel", style: { height: '100%' }, "data-cy": "1-panel", children: [(0, jsx_runtime_1.jsx)("h2", { className: "headline headline--1", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "login.login" }) }), (0, jsx_runtime_1.jsx)(login_form_1.default, { onSubmit: values => {
                                        login(values);
                                    }, loginError: loginError, isLoading: isLoginLoading })] }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, md: { span: 12 }, xl: { span: 10 }, children: (0, jsx_runtime_1.jsx)("div", { className: "panel", style: { height: '100%' }, "data-cy": "2-panel", children: (0, jsx_runtime_1.jsxs)("div", { className: "login__registration", children: [(0, jsx_runtime_1.jsxs)("div", { className: "login__registration-text", children: [(0, jsx_runtime_1.jsx)("h2", { className: "headline headline--1", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "login.registration" }) }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "login.dont_have_account_yet" }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", link: "/registracia", size: "middle", "data-cy": "company-register-button", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "login.i_am_empolyer" }) }) }), (0, jsx_runtime_1.jsx)(separator_1.default, { text: intl.formatMessage({
                                            id: 'login.or',
                                        }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-col align-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "m-b-l", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", link: "/registracia-uchadzac", size: "middle", "data-cy": "candidate-register-button", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "login.i_am_applicant" }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-col", children: [(0, jsx_runtime_1.jsx)(FacebookLoginButton_1.FacebookLoginButton, { type: auth_1.OAuthType.registration }), (0, jsx_runtime_1.jsx)(GoogleLoginButton_1.GoogleLoginButton, { type: auth_1.OAuthType.registration }), (0, jsx_runtime_1.jsx)(LinkedInLoginButton_1.LinkedInLoginButton, { type: auth_1.OAuthType.registration })] })] })] }) }) })] }) }) }));
}
